import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState ,useContext} from "react";
import "../../../../cssfiles/homepage.css";
import { useDispatch, useSelector } from "react-redux";
import Divider from "@mui/material/Divider";

import {
  gatewaylivedata,
  getgatewaylist,
  allorggatewaylivedata
} from "../../../../Restclient/datacollection";
import { updategatewaylist } from "../../../../store/diagnostic_data";
import { Typography } from "@mui/material";
import Box from "@mui/material/node/Box";
import { ThemeContext } from "../../../../pages/Homepage";
import CustomTooltip from "../../../CommonComponents/CustomTooltip";


export default function TableAllGateway(props) {
  const dispatch = useDispatch();
      const{ theme }= useContext(ThemeContext);
  

      const userdetails = useSelector(state => state.logindata.userdetails);
      const projectname = useSelector(state => state.mainpagedata.selectedprojectname)
      const projectdetails = useSelector((state) => state.logindata.projectdata);
      console.log("projectname at table all gateway", projectname, userdetails, projectdetails);


  const [tableHead, setTableHead] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [gatewayList, setGatewayList] = useState([]);
  const [gatewayId, setGatewayId] = useState([]);
  const [conn, setConn] = useState([]);

  function gatewaylivedatacallback(res) {
    console.log("gateway live data in table all gateway", res);
    if(res.status === 200 && res.data.type === "success"){

        setGatewayList(res.data.data)
    }else{
        setGatewayList([])
    }
  }


  useEffect(() => {
    allorggatewaylivedata(gatewaylivedatacallback);
  }, []);


  return (
    <Box sx={{display: 'flex', flexWrap: "wrap", width: '100%', padding: '8px', gap : '12px', overflowY: 'auto',boxSizing: 'border-box'}}>
      {projectdetails.map(project => (
        <>
        {project.ProjectId === 'All'?
        <>
        </>
        :
        <>
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 'calc(25% - 10px)',width: 'calc(25% - 10px)',height:'154px',padding:'8px',boxSizing:'border-box',background:"var(--SecondaryBackground)"}}>
                    {console.log("project details at table all gateway", gatewayList, project,gatewayList.filter(gateway => gateway.ProjectID === project.Projectid))}
                    <Typography sx={{textAlign:'left',width: '100%',fontWeight:700,padding:"2px 0px",color: "var(--SecondaryText)"}}>{project.Projectname}</Typography>    
                    <Divider variant="middle" orientation="horizontal"  style={{margin: "4px 2px 0px 2px",height: "1px", width:'100%', background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",}}/>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%',height:'calc(100% - 32px)',boxSizing:'border-box', marginTop:'0px', overflowY: 'auto', padding:'4px 0px', gap:'4px'}}>
                    {gatewayList.filter(gateway => gateway.ProjectID === project.ProjectId).map(filteredgateway => (
                        <>
                        {console.log("filtered gateway0000000000 at table all gateway",gatewayList.filter(gateway => gateway.ProjectID === project.ProjectId), gatewayList.filter(gateway => gateway.ProjectID === project.ProjectId).length)}
                        {gatewayList.filter(gateway => gateway.ProjectID === project.ProjectId).length === 0? (
                            <Typography sx={{textAlign:'center',width: '100%',marginTop:'16px',color: "var(--SecondaryText)",}}>No gateways found</Typography>
                        ) : (  
                        <>     
                            <Box sx={{display: 'flex', flexDirection: 'row', gap: '8px', width: '100%',padding:'4px 0px',boxSizing:'border-box'}}>
                                <CustomTooltip title={filteredgateway.Name} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
                                    <Typography sx={{textAlign:'left',width: '60%',whiteSpace: "nowrap",textOverflow: "ellipsis",overflow: "hidden",color: "var(--SecondaryText)",}}>{filteredgateway.Name}</Typography>
                                </CustomTooltip>
                                <Typography sx={{textAlign:'left',width: '40%',color:filteredgateway.Status === "Connected" ? "var(--GreenBaseColor)" : "var(--RedBaseColor)"}}>{filteredgateway.Status}</Typography>
                            </Box>
                        {/* <Divider variant="middle" orientation="horizontal" style={{margin: "0px 2px 0px 2px",height: "1px", width:'calc(100% - 8px)', background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",}}/> */}
                        </>
                        )}  
                        </>    
                    ))}
                    </Box>  
        </Box>
        </>
        }
        </>
        
      ))}
      
    </Box>
  );
}
